import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
const FormLocationInput = ({ user, handleInputChange, isEditable }) => {
  const { t } = useTranslation();
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const countryRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const username = "murataktas";

  const [suggestions, setSuggestions] = useState({
    country: [],
    city: [],
    state: [],
  });

  useEffect(() => {
    fetch(`http://api.geonames.org/countryInfoJSON?username=${username}`)
      .then((res) => res.json())
      .then((data) => {
        setCountryList(data.geonames);
      });
  }, []);

  useEffect(() => {
    const selectedCountry = countryList.find(
      (c) => c.countryName === user.country
    );
    if (selectedCountry) {
      fetch(
        `http://api.geonames.org/searchJSON?country=${selectedCountry.countryCode}&featureClass=P&maxRows=1000&username=${username}`
      )
        .then((res) => res.json())
        .then((data) => {
          setCityList(data.geonames);
        });
    }
  }, [user.country, countryList]);

  useEffect(() => {
    const selectedCity = cityList.find((c) => c.name === user.city);
    if (selectedCity?.geonameId) {
      fetch(
        `http://api.geonames.org/childrenJSON?geonameId=${selectedCity.geonameId}&username=${username}`
      )
        .then((res) => res.json())
        .then((data) => {
          setStateList(data.geonames || []);
        });
    }
  }, [user.city, cityList]);

  const handleFocus = (name) => {
    if (name === "country") {
      const filtered = countryList
        .filter((c) =>
          c.countryName
            .toLowerCase()
            .includes(user.country?.toLowerCase() || "")
        )
        .map((c) => c.countryName);
      setSuggestions((prev) => ({ ...prev, country: filtered }));
    }
    if (name === "city") {
      const filtered = cityList
        .filter((c) =>
          c.name.toLowerCase().includes(user.city?.toLowerCase() || "")
        )
        .map((c) => c.name);
      setSuggestions((prev) => ({ ...prev, city: filtered }));
    }
    if (name === "state") {
      const filtered = stateList
        .filter((s) =>
          s.name?.toLowerCase().includes(user.state?.toLowerCase() || "")
        )
        .map((s) => s.name);
      setSuggestions((prev) => ({ ...prev, state: filtered }));
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !countryRef.current?.contains(event.target) &&
        !cityRef.current?.contains(event.target) &&
        !stateRef.current?.contains(event.target)
      ) {
        setSuggestions({ country: [], city: [], state: [] });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderDropdown = (items, onSelect) => (
    <div className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
      {items.map((item, index) => (
        <button
          type="button"
          key={index}
          className="list-group-item list-group-item-action"
          onClick={() => onSelect(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );

  return (
    <div className="row">
      <div className="col-lg-4">
        <div className="mb-3 position-relative" ref={countryRef}>
          <label className="form-label">{t("UpdateCountryLabel")}</label>
          <input
            type="text"
            name="country"
            className="form-control"
            value={user.country}
            onChange={(e) => {
              handleInputChange(e);
              handleFocus("country");
            }}
            onFocus={() => handleFocus("country")}
            autoComplete="off"
            readOnly={!isEditable}
            style={{ height: "55px", width: "100%" }}
          />
          {user.country?.length > 0 &&
            suggestions.country.length > 0 &&
            renderDropdown(suggestions.country, (item) => {
              handleInputChange({ target: { name: "country", value: item } });
              handleInputChange({ target: { name: "city", value: "" } });
              handleInputChange({ target: { name: "state", value: "" } });
              setSuggestions((prev) => ({ ...prev, country: [] }));
            })}
        </div>
      </div>

      <div className="col-lg-4">
        <div className="mb-3 position-relative" ref={cityRef}>
          <label className="form-label">{t("UpdateCityLabel")}</label>
          <input
            type="text"
            name="city"
            className="form-control"
            value={user.city}
            onChange={(e) => {
              handleInputChange(e);
              handleFocus("city"); // <== YENİ
            }}
            onFocus={() => handleFocus("city")}
            autoComplete="off"
            readOnly={!isEditable}
            style={{ height: "55px", width: "100%" }}
          />
          {user.city?.length > 0 &&
            suggestions.city.length > 0 &&
            renderDropdown(suggestions.city, (item) => {
              handleInputChange({ target: { name: "city", value: item } });
              handleInputChange({ target: { name: "state", value: "" } });
              setSuggestions((prev) => ({ ...prev, city: [] }));
            })}
        </div>
      </div>

      <div className="col-lg-4">
        <div className="mb-3 position-relative" ref={stateRef}>
          <label className="form-label">{t("UpdateStateLabel")}</label>
          <input
            type="text"
            name="state"
            className="form-control"
            value={user.state}
            onChange={(e) => {
              handleInputChange(e);
              handleFocus("state"); // <== YENİ
            }}
            onFocus={() => handleFocus("state")}
            autoComplete="off"
            readOnly={!isEditable}
            style={{ height: "55px", width: "100%" }}
          />
          {user.state?.length > 0 &&
            suggestions.state.length > 0 &&
            renderDropdown(suggestions.state, (item) => {
              handleInputChange({ target: { name: "state", value: item } });
              setSuggestions((prev) => ({ ...prev, state: [] }));
            })}
        </div>
      </div>
    </div>
  );
};

export default FormLocationInput;
